import React from 'react';
import PropTypes from 'prop-types';
import LoadFromCatalogButton from '../loadFromCatalogButton/loadFromCatalogButton';
import Label from '../../atoms/label/label';
import { ButtonTheme } from '../../atoms/button/button';
import { IconType } from '../../atoms/icon/icon';

const FormLoadFromCatalog = (props) => {
  const {
    id,
    label,
    helpText,
    configFile,
    onClose,
  } = props;

  const handleOnClose = (value) => {
    const target = { target: { value } };
    onClose(target);
  };

  return (
    <div className="form-group row">
      { label !== ''
        && (
          <Label helpText={helpText}>{label}</Label>
        )}
      <div className="col-sm-8">
        <LoadFromCatalogButton
          id={id}
          onClose={handleOnClose}
          label={label}
          configFile={configFile}
          buttonText="Search"
          icon={IconType.SEARCH}
          buttonTheme={ButtonTheme.INFO}
        />
      </div>
    </div>
  );
};

FormLoadFromCatalog.propTypes = {
  /**
   * id of load from caalog button
   */
  id: PropTypes.string,
  /**
   * Name of input attribute
   */
  label: PropTypes.string,
  /**
   * Input help text
   */
  helpText: PropTypes.string,
  /**
   * Confinguration file to create a table
   */
  configFile: PropTypes.shape({}),
  /**
  * Event callback when the modal is closed
  */
  onClose: PropTypes.func,
};

FormLoadFromCatalog.defaultProps = {
  id: '',
  label: '',
  helpText: '',
  configFile: {},
  onClose: () => { },
};

export default FormLoadFromCatalog;
